<template>
    <vx-modal v-model:visible="visible" size="sm" padding="standard">
        <template v-slot:header>Deactivate campaign</template>
        <template v-slot:subheader>{{ props.campaignId }}</template>

        <div class="text-sm text-slate-800">
            This cannot be undone; the list shows the campaign as Expired once the sync catches up, about fifteen
            minutes.
        </div>

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button
                    @click="visible = false"
                    type="button"
                    class="grow lg:w-20 lg:grow-0"
                    size="lg"
                    color="muted"
                >
                    Cancel
                </vx-button>
                <vx-button
                    @click="confirm()"
                    data-test="confirm-deactivate"
                    :loading="deactivating"
                    type="button"
                    class="grow"
                    size="lg"
                    color="danger"
                >
                    Deactivate campaign
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script lang="ts" setup>
import { VxButton, VxModal } from '@voxie/frontend-components';
import { ref } from 'vue';
import { useCallout } from '~/composables/useCallout';
import { useToasted } from '~/composables/useToasted';
import { adminTenDlcRegistrationClient } from '~/services';
import dayjs from '~/utils/dayjs';
import { escapeHtml } from '~/utils/html';
import { catchRequestError } from '~/utils/request';

const props = defineProps<{ campaignId: string }>();
const visible = defineModel<boolean>('visible', { default: false });

const toasted = useToasted();
const callout = useCallout();

const deactivating = ref(false);

const confirm = async () => {
    if (deactivating.value) {
        return;
    }

    deactivating.value = true;

    try {
        await adminTenDlcRegistrationClient.deleteCampaign(props.campaignId);

        const id = escapeHtml(props.campaignId);

        callout.success(
            'kiosk-tcr-campaigns',
            `<strong>${id}</strong> deactivated; it shows as Expired once the sync catches up, about fifteen minutes`,
            {
                ttl: dayjs().add(30, 'seconds'),
                shadow: true,
            }
        );

        window.location.assign('/kiosk/ten-dlc/campaigns');
    } catch (e) {
        toasted.error(catchRequestError(e), { sticky: true });
    } finally {
        deactivating.value = false;
    }
};
</script>
